import styled from '@emotion/styled'
import {
  Button,
  Card,
  colors,
  spacing,
  ContentStylizer,
} from '@retailer-platform/shared-components'
import FeatureEducationBannerImage from 'assets/featureHighlights/feature-education-banner.png'
import React from 'react'

interface FeatureEducationBannerProps {
  onOpenFeatureEducationModal: () => void
  onDismiss: () => void
}

const StyledCardBody = styled('div')({
  display: 'flex',
})

const Image = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
})

const ImageWrapper = styled('div')({
  height: 240,
  width: 300,
  background: colors.SECONDARY.LIGHT,
  borderRadius: spacing.X16,
})

const StyledMarkdown = styled(ContentStylizer)({
  flex: 1,
})

const Details = styled('div')({
  padding: spacing.X8,
  marginLeft: spacing.X16,
  display: 'flex',
  flexDirection: 'column',
})

const ButtonWrapper = styled('div')({
  display: 'flex',
})

const StyledButton = styled(Button)({
  margin: 0,
  marginRight: spacing.X16,
})

const FeatureEducationBanner = ({
  onOpenFeatureEducationModal,
  onDismiss,
  ...props
}: FeatureEducationBannerProps) => (
  <Card {...props}>
    <StyledCardBody>
      <ImageWrapper>
        <Image src={FeatureEducationBannerImage} />
      </ImageWrapper>
      <Details>
        <StyledMarkdown>
          <h3>Introducing new tools on Instacart Platform Portal</h3>
          <p>
            Take control of your storefront experience to represent your brand and serve your
            customers. Learn more in our documentations.
          </p>
          <h4>Learn more about the tools</h4>
        </StyledMarkdown>
        <ButtonWrapper>
          <StyledButton onClick={onOpenFeatureEducationModal}>Check it out</StyledButton>
          <StyledButton onClick={onDismiss} variant="transparent">
            Dismiss
          </StyledButton>
        </ButtonWrapper>
      </Details>
    </StyledCardBody>
  </Card>
)

export default FeatureEducationBanner
